var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNegativeTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.5L16.29 10.21L11.41 5.33L7.41 9.33L0 1.91L1.41 0.5L7.41 6.5L11.41 2.5L17.71 8.79L20 6.5V12.5H14Z",
    fill: "#E02D3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegativeTrend);
export default __webpack_public_path__ + "static/media/negative_trend.4142f99ed76b8428d0ee3a65f74d5f7d.svg";
export { ForwardRef as ReactComponent };